import * as React from "react";
import * as moment from "moment";
import { observer } from "mobx-react";
import { observable } from "mobx";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Pager } from "../utils/Pager";
import { toast } from "react-toastify";
import { Dialog, Classes, Button, FormGroup, Alignment, Icon } from "@blueprintjs/core";
import { ManifestacoesStore } from "../../stores/manifestacoes/ManifestacoesStore";
import InfiniteScroll from "react-infinite-scroll-component";
import { getTag } from "../utils/getStatus";
import { formatCnpj, formatCpfOrCnpj } from "../../utils";
import { EmpresaSelect, filterEmpresa, renderEmpresa } from "../empresa/EmpresaSelect";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { IEmpresa, newEmpresa } from "../../model";
import { AppStore } from "../../stores/AppStore";

@observer
export default class CalculoManifestacoes extends React.Component<{}, {}> {

  obs = observable({
    tarefas_page: 1 as number,
    detalhes_manifestacao: false as boolean,
    detalheTab: "erros" as "erros" | "avisos",
    import_id: "" as string,
    erros_page: 1 as number,
    avisos_page: 1 as number,
    selectedEmpresa: newEmpresa() as IEmpresa,
    modelo: "" as string
  })

  constructor(props: any) {
    super(props);
  }

  handleBuscaClick = async () => {
    this.obs.tarefas_page = 1;

    const cnpj = this.obs.selectedEmpresa.cnpj || "";
    const modelo = this.obs.modelo;

    await ManifestacoesStore.handleConsultaTodas(1, 15, cnpj, modelo);
    await ManifestacoesStore.handldeItensProcessando(cnpj, modelo);
  };

  handleBuscaTarefas = async (page: number) => {
    const cnpj = this.obs.selectedEmpresa.cnpj || "";
    const modelo = this.obs.modelo;
    ManifestacoesStore.handleConsultaTodas(page, 15, cnpj, modelo);
  };

  handleCloseDetalhes() {
    this.obs.detalheTab = "erros"
    this.obs.detalhes_manifestacao = false
  }

  handleFilterModeloChange = (e: any) => {
    var string = e.target.value;
    this.obs.modelo = string;
  };

  render() {

    let niveis_acesso = AppStore.obs1.usuario
      ? AppStore.obs1.usuario.niveis_acesso
      : [""];

    let empresaText = this.obs.selectedEmpresa.razao_social != ""
      ? `${this.obs.selectedEmpresa.razao_social.substring(0, 35)}... (${formatCnpj(this.obs.selectedEmpresa.cnpj)
      })`
      : "Selecione uma empresa";

    function statusFormatter(cell, row) {

      return getTag(row.status, "manifestacao");
    }

    function dateFormatter(cell, row) {
      return moment(cell).add(3, "hour").format("DD/MM/YYYY") + " às " + moment(cell).add(3, "hour").format("HH:mm");
    };

    function stringFormatter(cell, row) {
      if (!cell) return "";
      return (cell).toUpperCase();
    };

    function getRazaoSocial(cell, row) {
      let emp = EmpresaStore.getByCnpj(cell);

      if (!emp) {
        return ""
      }

      return emp.razao_social

    }

    const handleViewDetalhes = async (row) => {
      await ManifestacoesStore.summary_manifestacao(row.manifestacao_id, row.tipo, row.modelo);

      if (!ManifestacoesStore.obs.isValida) {
        let manifestacaoId = ManifestacoesStore.obs.manifestacoes_summary.import._id
        this.obs.import_id = manifestacaoId
        this.obs.erros_page = 1
        this.obs.avisos_page = 1
        ManifestacoesStore.obs.avisos_manifestacoes = []
        ManifestacoesStore.obs.erros_manifestacoes = []

        await ManifestacoesStore.busca_erros_manifestacoes(this.obs.erros_page, manifestacaoId);
        await ManifestacoesStore.busca_avisos_manifestacoes(this.obs.avisos_page, manifestacaoId);

        this.obs.detalheTab = ManifestacoesStore.obs.erros_manifestacoes.length === 0 && ManifestacoesStore.obs.avisos_manifestacoes.length > 0
          ? "avisos"
          : "erros"

        this.obs.detalhes_manifestacao = true
      } else {
        toast.warning('Sem dados para mostrar.', {});
      }
    };

    function buttonFormatterDetalhes(cell, row) {
      return (
        <>
          <MDBBtn disabled={!row._id} color="default" rounded size="sm" onClick={(e) => handleViewDetalhes(row)} >
            <img src="/images/view.png" width="18px" />
          </MDBBtn>
        </>
      );
    }

    const renderErroItem = (obj, index) => {
      return (
        <div className="detalheImportItem detalheImportItem--erro" key={index}>
          <Icon icon="error" className="detalheImportItemIcon" />
          <span className="detalheImportItemMsg">{obj.mensagem}</span>
        </div>
      );
    };

    const renderAvisoItem = (obj, index) => {
      return (
        <div className="detalheImportItem detalheImportItem--aviso" key={index}>
          <Icon icon="warning-sign" className="detalheImportItemIcon" />
          <span className="detalheImportItemMsg">{obj.mensagem}</span>
        </div>
      );
    };

    let errosTextValidate = ManifestacoesStore.obs.erros_manifestacoes.length
    let errosText = ManifestacoesStore.obs.erros_manifestacoes?.map(renderErroItem)

    let avisosTextValidate = ManifestacoesStore.obs.avisos_manifestacoes.length
    let avisosText = ManifestacoesStore.obs.avisos_manifestacoes?.map(renderAvisoItem)

    const fetchMoreAvisos = async () => {
      this.obs.avisos_page = this.obs.avisos_page + 1
      await ManifestacoesStore.busca_avisos_manifestacoes(this.obs.avisos_page, this.obs.import_id)
    };

    const fetchMoreErros = async () => {
      this.obs.erros_page = this.obs.erros_page + 1
      await ManifestacoesStore.busca_erros_manifestacoes(this.obs.erros_page, this.obs.import_id)
    };

    function cnpjFormatter(cell, row) {

      return formatCpfOrCnpj(cell)

    }

    return (
      <>

        <MDBRow>
          <MDBCol xl="4" lg="4" md="4" sm="4" xs="12">
            <FormGroup label="Empresa" className="empresaSelect">
              <EmpresaSelect
                items={EmpresaStore.sortedEmpresas}
                itemRenderer={renderEmpresa}
                itemPredicate={filterEmpresa}
                onItemSelect={(e: IEmpresa) => this.obs.selectedEmpresa = e}
                inputProps={{ placeholder: "Filtrar uma empresa" }}
              >
                <Button
                  text={empresaText}
                  rightIcon="double-caret-vertical"
                  alignText={Alignment.LEFT}
                />
              </EmpresaSelect>
            </FormGroup>
          </MDBCol>
          <MDBCol xl="2" lg="2" md="2" sm="2" xs="12">
            <FormGroup
              label="Modelo"
              className="nz-horizontal-field selectFullWidth"
            >
              <select
                onChange={this.handleFilterModeloChange}
                className="bp3-button bp3-align-left"
              >
                <option value="">Todos</option>
                <option value="nfe">NF-e</option>
                <option value="nfce">NFC-e</option>
                <option value="cte">CT-e</option>
                <option value="nfse">NFS-e</option>
              </select>
            </FormGroup>
          </MDBCol>
          <MDBCol md="2">
            <MDBBtn
              className="btnDefault btnBuscarNfe mt25"
              onClick={this.handleBuscaClick}
              disabled={niveis_acesso.indexOf("h1") == -1}
            >
              Buscar
            </MDBBtn>
          </MDBCol>
        </MDBRow>

        <Dialog
          isOpen={this.obs.detalhes_manifestacao}
          title="Detalhes da Importação"
          onClose={() => this.handleCloseDetalhes()}
          className="detalhesImportDialog"
        >
          <div className={Classes.DIALOG_BODY}>
            <div className="detalheImportResumo">
              <div className="detalheImportResumoItem">
                <span className="detalheImportResumoNum">{ManifestacoesStore.obs.manifestacoes_summary.import.total}</span>
                <span className="detalheImportResumoLabel">Arquivos Processados</span>
              </div>
              <div className="detalheImportResumoItem">
                <span className="detalheImportResumoNum detalheImportResumoNum--ok">{ManifestacoesStore.obs.manifestacoes_summary.import.importados}</span>
                <span className="detalheImportResumoLabel">Arquivo(s) Calculado(s)</span>
              </div>
              <div className="detalheImportResumoItem">
                <span className={ManifestacoesStore.obs.manifestacoes_summary.import.erros >= 1
                  ? "detalheImportResumoNum detalheImportResumoNum--erro"
                  : "detalheImportResumoNum"}>{ManifestacoesStore.obs.manifestacoes_summary.import.erros}</span>
                <span className="detalheImportResumoLabel">Arquivo(s) com Erro(s)</span>
              </div>
            </div>

            {(!errosTextValidate && !avisosTextValidate) ?
              <div className="detalheImportSucesso">
                <img src="/images/pass_calculo.png" width={44} />
                <h3>Importação concluída com sucesso</h3>
                <p>Nenhum erro ou aviso foi encontrado nos arquivos importados.</p>
              </div>
              :
              <>
                <div className="detalheImportSeg">
                  {errosTextValidate ?
                    <button
                      type="button"
                      className={this.obs.detalheTab === "erros" ? "detalheImportSegBtn is-active" : "detalheImportSegBtn"}
                      onClick={() => this.obs.detalheTab = "erros"}
                    >
                      Erros
                      <span className="detalheImportSegCount detalheImportSegCount--erro">{errosTextValidate}</span>
                    </button> : null
                  }
                  {avisosTextValidate ?
                    <button
                      type="button"
                      className={this.obs.detalheTab === "avisos" ? "detalheImportSegBtn is-active" : "detalheImportSegBtn"}
                      onClick={() => this.obs.detalheTab = "avisos"}
                    >
                      Avisos
                      <span className="detalheImportSegCount detalheImportSegCount--aviso">{avisosTextValidate}</span>
                    </button> : null
                  }
                </div>

                <div className="detalheImportLista">
                  {this.obs.detalheTab === "avisos" && avisosTextValidate ?
                    <InfiniteScroll
                      dataLength={avisosText.length}
                      next={fetchMoreAvisos}
                      hasMore={true}
                      height={Math.min(300, Math.max(avisosText.length, 1) * 50)}
                      loader={""}
                    >
                      {avisosText}
                    </InfiniteScroll>
                    :
                    <InfiniteScroll
                      dataLength={errosText.length}
                      next={fetchMoreErros}
                      hasMore={true}
                      height={Math.min(300, Math.max(errosText.length, 1) * 45)}
                      loader={""}
                    >
                      {errosText}
                    </InfiniteScroll>
                  }
                </div>
              </>
            }
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Fechar" intent="primary" onClick={() => this.handleCloseDetalhes()} />
            </div>
          </div>
        </Dialog>

        <div data-tut="table">
          <BootstrapTable className="TableDefault" ref="table" data={ManifestacoesStore.obs.tasks_manifestacoes} data-tut="table">
            <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%"> # </TableHeaderColumn>
            <TableHeaderColumn dataFormat={cnpjFormatter} dataField="cnpj" width="10%">CNPJ</TableHeaderColumn>
            <TableHeaderColumn dataFormat={getRazaoSocial} dataField="cnpj" width="20%">Empresa</TableHeaderColumn>
            <TableHeaderColumn dataFormat={dateFormatter} dataField="inserted_at" width="10%">Data</TableHeaderColumn>
            <TableHeaderColumn dataFormat={stringFormatter} dataField="tipo" width="10%">Tipo</TableHeaderColumn>
            <TableHeaderColumn dataFormat={stringFormatter} dataField="modelo" width="10%">Modelo</TableHeaderColumn>
            <TableHeaderColumn dataFormat={statusFormatter} width="30%">Status</TableHeaderColumn>
            <TableHeaderColumn dataFormat={buttonFormatterDetalhes} width="10%">Detalhes</TableHeaderColumn>
          </BootstrapTable>
        </div>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={this.obs.tarefas_page}
            totalCount={ManifestacoesStore.obs.length_tasks_manifestacoes}
            pageSize={15}
            onPageChange={page => this.handleBuscaTarefas(this.obs.tarefas_page = page)}
          />
        </div>
      </>
    )
  }
}

